/**
 * Redux DevTools configuration optimized for memory and performance
 *
 * This configuration reduces memory usage and CPU consumption by:
 * - Limiting the number of actions stored in history (maxAge)
 * - Reducing trace limits
 * - Optimizing serialization options
 * - Disabling state persistence between page reloads
 *
 * @see https://github.com/reduxjs/redux-devtools-extension/blob/master/docs/Troubleshooting.md#excessive-use-of-memory-and-cpu
 */
export const devToolsConfig = {
	maxAge: 25, // Reduced from 50 to save memory - keeps only last 25 actions
	trace: false, // Disable stack trace for better performance
	traceLimit: 10, // Reduced from 25 - limit stack trace depth
	latency: 0, // Minimize latency overhead
	// Serialize options to reduce memory consumption
	serialize: {
		options: {
			undefined: true, // Allow undefined values in serialization
			function: false, // Don't serialize functions
			symbol: false // Don't serialize symbols
		}
	},
	// Features configuration to reduce overhead
	features: {
		pause: true, // Allow pausing action recording
		lock: true, // Allow locking state changes
		persist: false, // Don't persist state between page reloads - saves memory
		export: true, // Allow exporting state
		import: "custom" as const, // Allow custom import
		jump: true, // Allow jumping to specific actions
		skip: true, // Allow skipping actions
		reorder: true, // Allow reordering actions
		dispatch: true, // Allow dispatching actions
		test: false // Disable test mode
	}
};
